import { render, staticRenderFns } from "./SwitchDebug.vue?vue&type=template&id=1d9a4d78&scoped=true&"
import script from "./SwitchDebug.vue?vue&type=script&lang=js&"
export * from "./SwitchDebug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a4d78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
